<div class="qrcode-modal-overlay" *ngIf="isQRCodeModalOpen">
  <div class="qrcode-modal">
    <div class="qrcode-modal-header">
      <h2 style="color: var(--dark-color)">QR Code</h2>
      <button class="qrcode-modal-close" (click)="closeQRCodeModal()">&times;</button>
    </div>
    <div class="qrcode-modal-body">
      <p>{{contadorQrCode}}</p>
      <div class="qrcode-container" [innerHTML]="sanitizedQRCode"></div>
    </div>
  </div>
</div>
